import { render, staticRenderFns } from "./PackingSlipBottomText.vue?vue&type=template&id=0a1c9a8c"
import script from "./PackingSlipBottomText.vue?vue&type=script&lang=js"
export * from "./PackingSlipBottomText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports